import { z } from 'zod';

/** Generic error payload returned by the backend for any non-2xx response. */
export const apiErrorSchema = z.object({
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ApiErrorBody = z.infer<typeof apiErrorSchema>;
